import { useTranslation } from "@coworker/locales";
import {
  BooleanFilterValue,
  CheckboxFilter,
  FilterType,
  InputType,
} from "../../shared/filters/types/filter";

const PRIORITY_ONLY_ID = "priority";

export function usePriorityOnlyFilter(): CheckboxFilter {
  const { t } = useTranslation();

  const defaultValue = {
    filterId: PRIORITY_ONLY_ID,
    value: false,
  } as BooleanFilterValue;

  return {
    inputType: InputType.Checkbox,
    filterType: FilterType.Filter,
    id: PRIORITY_ONLY_ID,
    title: t("priorityTasksOnlyString"),
    defaultValue,
    enabled: true,
  };
}
